import React from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import MainContent from './MainContent';

const MainLayout = ({
    children,
    isSidebarCollapsed,
    onToggleSidebar,
    user,
    onLogout,
    onAddClick,
    onSettingsClick,
    onOpenPalette,
    // --- INÍCIO DA ALTERAÇÃO ---
    onOpenAvatarModal, 
    // --- FIM DA ALTERAÇÃO ---
    currentView,
    onViewChange,
    onCloseDetails
}) => {
    return (
        <div className="min-h-screen">
            <Sidebar
                view={currentView}
                onViewChange={onViewChange}
                onCloseDetails={onCloseDetails}
                isCollapsed={isSidebarCollapsed}
            />
            
            <div className={`relative transition-all duration-300 ease-in-out ${isSidebarCollapsed ? 'md:ml-20' : 'md:ml-64'}`}>
                <Navbar
                    user={user}
                    onLogout={onLogout}
                    onAddClick={onAddClick}
                    onSettingsClick={onSettingsClick}
                    onOpenPalette={onOpenPalette}
                    // --- INÍCIO DA ALTERAÇÃO: Passando a prop correta e removendo a antiga ---
                    onOpenAvatarModal={onOpenAvatarModal}
                    // onAvatarUpload foi removido
                    // --- FIM DA ALTERAÇÃO ---
                    onToggleSidebar={onToggleSidebar}
                />
                
                <MainContent key={currentView}>
                    {children}
                </MainContent>
            </div>
        </div>
    );
};

export default MainLayout;